export default "__VITE_ASSET__C8TTmX15__"